var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4899 5.85237C20.8476 6.27318 20.7964 6.90427 20.3756 7.26196L11.272 15L20.3756 22.7381C20.7964 23.0958 20.8476 23.7269 20.4899 24.1477C20.1322 24.5685 19.5011 24.6196 19.0803 24.262L9.97674 16.5239C9.03713 15.7252 9.03713 14.2748 9.97674 13.4761L19.0803 5.73808C19.5011 5.38039 20.1322 5.43156 20.4899 5.85237Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.3b729e3d56820d84eb8ce48c1498d6af.svg";
export { ForwardRef as ReactComponent };